import { LogLevel, LogSink } from "./models";

export default class ConsoleLogger implements LogSink {
  private logLevelMap: { [index: string]: (message: string) => any } = {
    TRACE: console.debug,
    DEBUG: console.debug,
    INFO: console.info,
    WARN: console.warn,
    ERROR: console.error,
    FATAL: (message: string) =>
      console.error("%c" + message, "font-size: 1.4em; font-weight: bold")
  };

  async push(logLevel: LogLevel, message: string) {
    this.logLevelMap[logLevel](message);
  }
}
